import { Route, Switch, useHistory } from "react-router-dom";
import { Suspense, lazy } from "react";

import Forbidden from "../auth-views/errors/forbidden";
import Loading from "components/shared-components/Loading";
import { useAuth } from "contexts/useAuth";
import { useCan } from "utils/hooks/useCan";

export const FranchiseeGlobalViews = () => {
  const RouteAuth = ({
    path,
    permissions = [],
    component: Component,
    ...rest
  }) => {
    const pathName = path.replace("/", "").replace("/", ".");

    const reports = path.split("/").includes("reports");

    const hasAbility = useCan({ permissions: [...(permissions ?? pathName)] });


    return hasAbility || reports ? (
      <Route {...rest} path={path} component={Component} />
    ) : (
      <Forbidden />
    );
  };

  const groups = [
    {
      group: 'Gestão de notas fiscais',
      description: 'Gestão de notas fiscais da plataforma',
      routes: [
        {
          permissions: ['invoices.products.index'],
          description: 'Listagem de faturas de produtos',
          path: '/invoices/products/index',
          component: lazy(() => import('./Franchise/pages/Invoices/ProductInvoice')),
        },
        {
          permissions: ['invoices.services.index'],
          description: 'Listagem de faturas de serviços',
          path: '/invoices/services/index',
          component: lazy(() => import('./Franchise/pages/Invoices/ServiceInvoice')),
        },
        {
          permissions: ['invoices.store'],
          description: 'Criar nova fatura',
          path: '/invoices/store',
          component: lazy(() => import('./Franchise/pages/Invoices/Create')),
        },
      ]
    },

    {
      group: 'Gestão Financeira',
      description: 'Gerenciamento financeiro da franqueadora',
      routes: [
        {
          permissions: [],
          description: 'Painel de cobranças',
          path: '/franchise-charges/index',
          component: lazy(() => import('./Franchise/pages/FranchiseCharges/')),
        },
        {
          permissions: [],
          description: 'Fluxo de caixa',
          path: '/cash-flow/index',
          component: lazy(() => import('./Franchise/pages/CashFlow/')),
        },
      ]
    },
    {
      group: "Suporte",
      description: "Gerenciamento de suporte",
      routes: [
          {
              permissions: [],
              description: "Listagem de chamados",
              path: "/suport/calls/index",
              component: lazy(() =>
                  import("./Franchise/pages/Suport/Calls/")
              ),
          },
          {
              permissions: [],
              description: "Departamentos",
              path: "/suport/service-call-sectors/index",
              component: lazy(() =>
                  import("./Franchise/pages/Suport/Sectors")
              ),
          },
          {
              permissions: [],
              description: "Visualização de chamados",
              path: "/suport/calls/:id/view",
              component: lazy(() =>
                  import("./Franchise/pages/Suport/Calls/View/")
              ),
          },
          {
              permissions: [],
              description: "Criar chamado",
              path: "/suport/calls/store",
              component: lazy(() =>
                  import("./Franchise/pages/Suport/Calls/Create")
              ),
          },
          {
              permissions: [],
              description: "Listagem de áreas",
              path: "/suport/areas/index",
              component: lazy(() =>
                  import("./Franchise/pages/Suport/Areas/")
              ),
          },
      ],
  },
    {
      group: 'Relatórios',
      description: '',
      routes: [
        {
          path: `/reports/financial/financial-balance`,
          component: lazy(() => import(`./Franchise/pages/Reports/Financial/balance`)),
        },
        {
          path: `/reports/financial/cash-flow`,
          component: lazy(() => import(`./Franchise/pages/Reports/Financial/cash-flow`)),
        },
        {
            path: `/reports/financial/franchisor-royalties`,
            component: lazy(() => import(`./FranchiseeAdminGlobal/pages/Reports/Financial/franchisor-royalties`)),
        }
      ]

    }
  ]

  const allRoutes = groups.flatMap((group) => group.routes);




  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>

        {allRoutes.map(({ component, path }) => <RouteAuth path={path} component={component} />)}

        {/* Refatorar as outras rotas */}


        <RouteAuth
          permissions={["dashboard.index"]}
          path={`/dashboard`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Dashboard/`)
          )}
        />

        <RouteAuth
          permissions={[]}
          path={`/school-calendar/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/SchoolCalendar`)
          )}
        />

        <RouteAuth
          permissions={["calendar-events-types.index"]}
          path={`/event-types/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/EventType/`)
          )}
        />

        <RouteAuth
          permissions={["calendar-events-types.store"]}
          path={`/event-types/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/EventType/Create/index`)
          )}
        />

        {/* Períodos */}
        <RouteAuth
          path={`/academic-year`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/AcademicYear`)
          )}
        />
        <RouteAuth
          path={`/periods/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/PeriodYear/Create`)
          )}
        />
        <RouteAuth
          path={`/periods/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/PeriodYear`)
          )}
        />

        <RouteAuth
          path={`/course-periods/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Course/CoursePeriod/Create`)
          )}
        />

        <RouteAuth
          path={`/course-periods/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Course/CoursePeriod`)
          )}
        />

        {/* Cargos */}
        <RouteAuth
          path={`/roles/index`}
          component={lazy(() => import(`./FranchiseeAdminGlobal/pages/Role`))}
        />
        <RouteAuth
          path={`/roles/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Role/Create`)
          )}
        />

        {/* Nivelamento */}

        {/* Lista de níveis de categoria */}
        <RouteAuth
          path={`/levelings/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Leveling/Category`)
          )}
        />

        <RouteAuth
          path={`/levelings/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Leveling/Category/Create`)
          )}
        />

        <RouteAuth
          path={`/leveling-categories/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Leveling/QuestionCategory`)
          )}
        />

        <RouteAuth
          path={`/leveling-categories/store`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Leveling/QuestionCategory/Create`
            )
          )}
        />

        <RouteAuth
          path={`/leveling/questions/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Leveling/Questions/Create`)
          )}
        />

        {/* Calendar */}
        <RouteAuth
          permissions={["calendar-events.index"]}
          path={`/calendar/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Calendar`)
          )}
        />
        <RouteAuth
          permissions={["calendar-events.store"]}
          path={`/calendar/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Calendar/Create`)
          )}
        />

        {/* grade horária */}

        <RouteAuth
          permissions={["team-schedules.index"]}
          path={`/team-schedule`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/TeamSchedules/`)
          )}
        />

        {/* franquia */}

        <RouteAuth
          path={`/franchises/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Franchisee/Create`)
          )}
        />

        {/* 
                <RouteAuth
                    
                    path={`/franchisee/store`}
                    component={lazy(() => import(`../auth-views/errors/forbidden`))}
                /> */}

        <RouteAuth
          path={`/franchises/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Franchisee/`)
          )}
        />

        {/* Editar dados da franquia */}
        <RouteAuth
          path={`/franchises/update`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Franchisor`)
          )}
        />

        {/* Posts */}
        <RouteAuth
          path={`/posts/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Blog/Create`)
          )}
        />
        <RouteAuth
          path={`/posts/index`}
          component={lazy(() => import(`./FranchiseeAdminGlobal/pages/Blog/`))}
        />

        <RouteAuth
          path={`/post-categories/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Blog/Categories/Create`)
          )}
        />
        <RouteAuth
          path={`/post-categories/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Blog/Categories/`)
          )}
        />

        {/* multfranquia */}
        <RouteAuth
          path={`/multfranchisee/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/MultFranchisee/`)
          )}
        />
        <RouteAuth
          path={`/multfranchisee/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/MultFranchisee/Create`)
          )}
        />

        {/* Curso */}
        <RouteAuth
          path={`/courses/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Course/`)
          )}
        />
        <RouteAuth
          path={`/courses/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Course/Create`)
          )}
        />
        <RouteAuth
          path={`/course-categories/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Course/Category/`)
          )}
        />
        <RouteAuth
          path={`/course-categories/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Course/Category/Create`)
          )}
        />
        <RouteAuth
          path={`/course-sub-categories/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Course/SubCategory/`)
          )}
        />
        <RouteAuth
          path={`/course-sub-categories/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Course/SubCategory/Create`)
          )}
        />
        <RouteAuth
          path={`/course/trail/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Course/Trail/`)
          )}
        />
        <RouteAuth
          path={`/course/trail/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Course/Trail/Create`)
          )}
        />
        <RouteAuth
          path={`/profile-management/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Profile`)
          )}
        />

        <RouteAuth
          path={`/evaluation/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Evaluation`)
          )}
        />
        <RouteAuth
          path={`/evaluation/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Evaluation/Create`)
          )}
        />

        <RouteAuth
          path={`/evaluation-methods/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Evaluation/EvaluationMethods`)
          )}
        />
        <RouteAuth
          path={`/evaluation-methods/store`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Evaluation/EvaluationMethods/Create`
            )
          )}
        />
        <RouteAuth
          path={`/evaluation-types/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Evaluation/EvaluationType`)
          )}
        />
        <RouteAuth
          path={`/evaluation-types/store`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Evaluation/EvaluationType/Create`
            )
          )}
        />
        <RouteAuth
          path={`/evaluation-grades/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Evaluation/EvaluationNotes`)
          )}
        />
        <RouteAuth
          path={`/evaluation-grades/store`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Evaluation/EvaluationNotes/Create`
            )
          )}
        />

        {/* Usuários */}
        <RouteAuth
          path={`/users/index`}
          component={lazy(() => import(`./FranchiseeAdminGlobal/pages/Users`))}
        />
        <RouteAuth
          path={`/users/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Users/Create`)
          )}
        />

        {/* Alunos */}
        <RouteAuth
          permissions={['enrollments.index']}
          exact
          path={`/enrollments/index`}
          component={lazy(() => import(`./FranchiseeAdminGlobal/pages/Enrollments/index`))}
        />

        <RouteAuth
          permissions={['enrollments.store']}
          exact
          path={`/enrollments/store`}
          component={lazy(() => import(`./FranchiseeAdminGlobal/pages/Enrollments/Create/`))}
        />

        <RouteAuth
          permissions={["enrollments.renovation"]}
          exact
          path={`/enrollments/renovation`}
          component={lazy(() => import(`./Franchise/pages/Student/Renovation`))}
        />
        <RouteAuth
          permissions={["students.index"]}
          exact
          path={`/students/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Users/Students/`)
          )}
        />

        {/* multfranquia */}
        <RouteAuth
          path={`/multfranchisee/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/MultFranchisee/`)
          )}
        />
        <RouteAuth
          path={`/multfranchisee/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/MultFranchisee/Create`)
          )}
        />
        {/* Produto */}
        <RouteAuth
          path={`/products/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Product/`)
          )}
        />
        <RouteAuth
          path={`/products/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Product/Create`)
          )}
        />

        <RouteAuth
          path={`/product-categories/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Product/Category`)
          )}
        />
        <RouteAuth
          path={`/product-categories/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Product/Category/Create`)
          )}
        />
        {/* Espaço fisíco */}

        {/* Canais de contato */}
        <RouteAuth
          path={`/contact-channels/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/ContactChannels/`)
          )}
        />
        <RouteAuth
          path={`/contact-channels/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/ContactChannels/Create/`)
          )}
        />

        {/* Prédios */}
        <RouteAuth
          path={`/buildings/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/PhysicalSpace/Buildings/`)
          )}
        />
        <RouteAuth
          path={`/buildings/store`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/PhysicalSpace/Buildings/Create`
            )
          )}
        />
        {/* Salas */}
        <RouteAuth
          path={`/room-types/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/PhysicalSpace/Rooms/`)
          )}
        />
        <RouteAuth
          path={`/room-types/store`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/PhysicalSpace/Rooms/Create`)
          )}
        />

        {/* Turmas */}
        <RouteAuth
          exact
          path={`/teams/store`}
          component={lazy(() => import(`./Franchise/pages/Class/Create`))}
        />
        <RouteAuth
          exact
          path={`/teams/index`}
          component={lazy(() => import(`./Franchise/pages/Class/`))}
        />

        {/* Relátorios */}

        <RouteAuth
          path={`/reports/sales/didactic-material`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Reports/Marketing/material`)
          )}
        />

        <RouteAuth
          path={`/reports/academic/teams`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Reports/Academic/teams`)
          )}
        />
        <RouteAuth
          path={`/reports/academic/scholarships`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Academic/scholarships`
            )
          )}
        />
        <RouteAuth
          path={`/reports/academic/frequency`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Reports/Academic/frequency`)
          )}
        />
        <RouteAuth
          path={`/reports/academic/enrollment-analytics`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Academic/enrollment-analytics`
            )
          )}
        />
        <RouteAuth
          path={`/reports/academic/synthetical-enrollments`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Academic/synthetical-enrollments`
            )
          )}
        />

        <RouteAuth
          path={`/reports/brand-funds/management-brand-funds`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Brand-funds/management-brand-funds`
            )
          )}
        />

        <RouteAuth
          path={`/reports/royalties/royalties-analytics`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Royalties/royalties-analytics`
            )
          )}
        />

        <RouteAuth
          path={`/reports/royalties/royalties-management`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Royalties/royalties-management`
            )
          )}
        />


        <RouteAuth
          path={`/reports/royalties/invoice-management`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Royalties/invoice-moviment-royalties`
            )
          )}
        />

        <RouteAuth
          path={`/reports/academic/evaluation-analytics`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Academic/evaluation-analytics`
            )
          )}
        />
        <RouteAuth
          path={`/reports/academic/grades`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Reports/Academic/grades`)
          )}
        />

        <RouteAuth
          abilities={["*"]}
          path={`/reports/sales/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Reports/Sales/`)
          )}
        />
        <RouteAuth
          abilities={["*"]}
          path={`/reports/sales/sales-analytics`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Sales/sales-analytics`
            )
          )}
        />
        <RouteAuth
          exact
          path={`/reports/financial/financial-statement`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Financial/financial-statement`
            )
          )}
        />
        <RouteAuth
          exact
          path={`/reports/financial/invoice-statement`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Financial/invoice-statement`
            )
          )}
        />
        <RouteAuth
          exact
          path={`/reports/financial/consolidated-receivables`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Financial/consolidated-receivables`
            )
          )}
        />
        <RouteAuth
          exact
          path={`/reports/financial/withdraw-conciliation`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Financial/withdraw-conciliation`
            )
          )}
        />
        <RouteAuth
          exact
          path={`/reports/financial/consolidated-statement`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Financial/consolidated-statement`
            )
          )}
        />
        <RouteAuth
          exact
          path={`/reports/financial/analytical-incomes`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Financial/analytical-incomes`
            )
          )}
        />
        <RouteAuth
          abilities={["*"]}
          path={`/reports/financial/synthetical-incomes`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Financial/synthetical-incomes`
            )
          )}
        />
        <RouteAuth
          abilities={["*"]}
          path={`/reports/financial/settled`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Reports/Financial/settled`)
          )}
        />
        <RouteAuth
          abilities={["*"]}
          path={`/reports/financial/revenue-manager`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Financial/revenue-manager`
            )
          )}
        />
        <RouteAuth
          abilities={["*"]}
          path={`/reports/financial/defaulter`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Reports/Financial/defaulter`)
          )}
        />
        <RouteAuth
          abilities={["*"]}
          path={`/reports/financial/bills-receive`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Financial/bills-receive`
            )
          )}
        />
        <RouteAuth
          abilities={["*"]}
          path={`/reports/financial/forecast`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Reports/Financial/forecast`)
          )}
        />

        <RouteAuth
          abilities={["*"]}
          path={`/reports/access/leads`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Reports/Access/leads`)
          )}
        />
        <RouteAuth
          abilities={["*"]}
          path={`/reports/access/access-environment`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Access/access-environment`
            )
          )}
        />
        <RouteAuth
          abilities={["*"]}
          path={`/reports/access/manage-access`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Reports/Access/manage-access`)
          )}
        />
        <RouteAuth
          abilities={["*"]}
          path={`/reports/marketing/follow-up`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Reports/Marketing/follow-up`)
          )}
        />
        <RouteAuth
          abilities={["*"]}
          path={`/reports/marketing/newsletter`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Reports/Marketing/newsletter`)
          )}
        />
        <RouteAuth
          abilities={["*"]}
          path={`/reports/marketing/campaigns`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Reports/Marketing/campaigns`)
          )}
        />
        <RouteAuth
          abilities={["*"]}
          path={`/reports/marketing/consultants`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Reports/Marketing/consultants`
            )
          )}
        />
        <RouteAuth
          abilities={["*"]}
          path={`/reports/marketing/birthdays`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Reports/Marketing/birthdays`)
          )}
        />

        {/* Desconto e Promoções*/}
        <RouteAuth
          path={`/discount-management/index`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/DiscountManagement/index`)
          )}
        />

        {/* Bolsas de estudo*/}
        <RouteAuth
          path={`/discount-management/scholarship/index`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/DiscountManagement/Scholarship/index`
            )
          )}
        />

        {/* Bolsas de estudo*/}
        <RouteAuth
          path={`/discount-management/scholarship/store`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/DiscountManagement/Scholarship/Create/index`
            )
          )}
        />

        {/* Configurações */}
        <RouteAuth
          path={`/configuration`}
          component={lazy(() => import(`./FranchiseeAdminGlobal/pages/Config`))}
        />

        {/* Website */}
        <RouteAuth
          path={`/website/courses/category`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Site/Courses/Category/`)
          )}
        />

        {/*Minha conta */}
        <RouteAuth
          exact
          path={`/myaccount`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/MyAccount`)
          )}
        />

        {/* Configurar curso */}

        <RouteAuth
          exact
          path={`/courses/:id/configuration`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Course/Configure`)
          )}
        />

        <RouteAuth
          exact
          path={`/courses/:id/course-periods`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Course/CoursePeriod`)
          )}
        />

        <RouteAuth
          exact
          path={`/courses/:id/product-management`}
          component={lazy(() =>
            import(
              `./FranchiseeAdminGlobal/pages/Course/Configure/ProductManagement`
            )
          )}
        />

        <RouteAuth
          exact
          path={`/courses/:id/modules`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Course/Configure/Modules`)
          )}
        />

        <RouteAuth
          exact
          path={`/courses/:id/curricular-grid`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Course/Configure/CurricularGrid`)
          )}
        />

        <RouteAuth
          exact
          path={`/courses/:id/curricular-grid/:grid/modules`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Course/Configure/Modules`)
          )}
        />

        <RouteAuth
          exact
          path={`/courses/:id/curricular-grid/:grid/modules/:module/lesson/:lesson/activities`}
          component={lazy(() =>
            import(`./FranchiseeAdminGlobal/pages/Course/Configure/Modules/LessonActivities`)
          )}
        />


        {/* Contas a pagar*/}
        <RouteAuth
          exact
          path={`/bills-to-pay`}
          component={lazy(() => import(`./Franchise/pages/BillsToPay`))}
        />

        {/* Categorias de contas */}
        <RouteAuth
          path={`/bill-categories/`}
          component={lazy(() => import(`./Franchise/pages/BillCategories/Categories`))}
        />


        {/* Contas Corrente */}

        <RouteAuth
          exact
          path={`/current_accounts/index`}
          component={lazy(() => import(`./Franchise/pages/CurrentAccounts/`))}
        />



        {/* Contas a receber*/}
        <RouteAuth
          exact
          path={`/bills-to-receive`}
          component={lazy(() => import(`./Franchise/pages/BillsToReceive`))}
        />



        {/* Fornecedores */}


        <RouteAuth
          exact
          path={`/providers/index`}
          component={lazy(() => import(`./Franchise/pages/Providers/`))}
        />
        <RouteAuth
          exact
          path={`/providers/store`}
          component={lazy(() => import(`./Franchise/pages/Providers/Create/`))}
        />


      </Switch>
    </Suspense>
  );
};
